import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  FormControl
} from "@angular/forms";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute, Params } from "@angular/router";

import { environment } from "../../../../environments/environment";
import { CrudService } from "../../../crud/crud.service";
import { NotificationsService } from 'angular2-notifications';

import { Mensaje } from "../../../mensaje";

import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import * as jQuery from 'jquery';
import * as moment from 'moment';

import { materialize } from 'rxjs/operators';

@Component({
  selector: "app-constancia",
  templateUrl: "./lista.component.html"
})
export class ConstanciaComponent implements OnInit{
  dato;

  configuracion = JSON.parse(localStorage.getItem("configuracion"));
  API_PATH = environment.API_PATH;

  cargando = false;
  evento;;
  mensajeResponse: Mensaje = new Mensaje(true);
  //mostrar notificaciones
  public options = {
    position: ["middle", "center"],
    timeOut: 3000,
    lastOnBottom: true
  };

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private crudService: CrudService,
    private notificacion: NotificationsService
  ) { }
  ngOnInit() {
    document.getElementById("catalogos").click();
  }
  seleccionarEvento(event) {
    this.evento = event.value;
  }

  cargarDatos() {
    this.dato = {};
    if (this.evento) {
      try {
        this.cargando = true;
        this.crudService.ver(this.evento, "evento-constancia")
          .subscribe(
            resultado => {
              this.cargando = false;

              if (resultado.status == 200) {
                this.dato = resultado.data;
              } else {
                this.mensajeResponse.titulo = "Sin datos";
                this.mensajeResponse.texto = "Los alumnos no tienen calificación";
                this.mensajeResponse.clase = "warning";
                this.mensaje(3);
              }
            },
            error => {
              this.cargando = false;
            }
          );

      } catch (e) {
        console.log(e);
      }
    } else {
      this.mensajeResponse.titulo = "Sin evento";
      this.mensajeResponse.texto = "Seleccione un evento";
      this.mensajeResponse.clase = "warning";
      this.mensaje(3);
    }
  }

  mensaje(
    cuentaAtras: number = 6,
    posicion: any[] = ["middle", "center"]
  ): void {
    let objeto = {
      showProgressBar: true,
      pauseOnHover: true,
      clickToClose: true,
      maxLength: this.mensajeResponse.texto.length
    };

    this.options = {
      position: posicion,
      timeOut: cuentaAtras * 1000,
      lastOnBottom: true
    };

    if (this.mensajeResponse.clase == "alert")
      this.notificacion.alert(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "success")
      this.notificacion.success(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "info")
      this.notificacion.info(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "warning" ||
      this.mensajeResponse.clase == "warn"
    )
      this.notificacion.warn(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "error" ||
      this.mensajeResponse.clase == "danger"
    )
      this.notificacion.error(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );
  }


  imprimirEvento() {
    let color = "#FFFFFF"; //$(".hero.is-primary").css("background-color");
    let tamanio = this.dato.eventos_constancias[0].tamanio_papel.split(":");
    let orientacion = this.dato.eventos_constancias[0].orientacion;;
    let doc = new jsPDF(orientacion, "mm", tamanio);

    let width = doc.internal.pageSize.getWidth();
    let height = doc.internal.pageSize.getHeight();

    this.dato.eventos_constancias.forEach((par, key) => {
      doc.setFontSize(par.font_size);
      doc.setFont(par.font_family);
      doc.setTextColor(par.color);
      this.dato.confirmados.forEach((per, k) => {
        doc.addImage(par.fondo, "PNG", 0, 0, width, height, "left", "FAST");
        doc.text(per.apellido_paterno + " " + per.apellido_materno + " " + per.nombre, par.mm_x, par.mm_y, {align:'center'});
        if (k > 0 && k < (this.dato.confirmados.length - 1))
        doc.addPage();
      });

      if (key < (this.dato.eventos_constancias.length - 1))
        doc.addPage();
    });

    // doc.autoPrint();
    //const string = (doc as any).output('datauristring', 'evento_confirmados.pdf');
    window.open((doc as any).output('bloburl'), '_blank');
    /*const iframe = "<iframe border='0' style='border:0px' width='100%' height='100%' src='" + string + "'></iframe>"

    const x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();*/
  }

  imprimirConfirmado() {
    let color = "#FFFFFF"; //$(".hero.is-primary").css("background-color");

    let doc = new jsPDF("p", "mm", "letter");

    let logo = this.logo_sucursal != '' ? this.logo_sucursal : this.logo_empresa;
    if (logo != '' && logo != undefined && logo != null)
      doc.addImage(logo, "PNG", 7, 5, 30, 20, "left", "FAST");

    //Nombre empresa
    doc.setFontSize(15);
    doc.setFont("helvetica", "", "bold");
    doc.setFont("helvetica");
    doc.text(this.configuracion.empresa.nombre,108, 12,  {align:"center"});

    doc.setFontSize(14);
    doc.setFont("helvetica", "", "bold");
    doc.text(this.configuracion.empresa.subnombre, 108, 18, {align:"center"});

    doc.setFontSize(10);
    doc.setFont("helvetica", "", "normal");
    doc.text('Campus: ' + this.configuracion.sucursal.nombre, 108, 24, {align:'center'});

    doc.setFontSize(10);
    doc.setFont("helvetica", "", "bold");
    doc.text("LISTA DE ASISTENCIA",108, 30,  {align:"center"});

    doc.setFontSize(8);
    doc.setFont("helvetica", "", "bold");

    doc.text("EVENTO: " + this.dato.nombre,15, 40,  {align:"left"});
    doc.text("FECHA: del " + this.dato.fecha_inicio + " al " + this.dato.fecha_termino,15, 45,  {align:"left"});


    let columns = [
      { title: "N", dataKey: "id" },
      { title: "Nombre", dataKey: "nombre" },
      { title: "Correo", dataKey: "correo" },
      { title: "Telefono", dataKey: "telefono" },
      { title: "Codigo", dataKey: "codigo" },
      { title: "Asistencia", dataKey: "asistencia" }
    ];

    let rows = []; let linea = 1;
    this.dato.confirmados.forEach(par => {
      rows.push({
        id: linea,
        nombre: par.apellido_paterno + " " + par.apellido_materno + " " + par.nombre,
        correo: par.email,
        telefono: par.telefono,
        codigo: par.codigo_confirmacion,
        asistencia: ''
      });
    });

    (doc as any).autoTable({
            columns:columns, 
            body: rows,
      didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
        cell.styles.fillColor = "#ffffff";
      },
      startY: 50,
      styles: {
        fontSize: 8,
        halign: "center",
        fillColor: color
      },
      theme: "grid",
      columnStyles: {
        id: { cellWidth: 20 },
        alumno: {
          cellWidth: 40,
          halign: "left"
        },
        asistencia: { cellWidth: 20 }
      }
    });

    // doc.autoPrint();
    //const string = (doc as any).output('datauristring', 'evento_confirmados.pdf');
    window.open((doc as any).output('bloburl'), '_blank');
    /*const iframe = "<iframe border='0' style='border:0px' width='100%' height='100%' src='" + string + "'></iframe>"

    const x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();*/

  }

  imprimirInscritos() {
    let color = "#FFFFFF"; //$(".hero.is-primary").css("background-color");

    let doc = new jsPDF("p", "mm", "letter");

    let logo = this.logo_sucursal != '' ? this.logo_sucursal : this.logo_empresa;
    if (logo != '' && logo != undefined && logo != null)
      doc.addImage(logo, "PNG", 7, 5, 30, 20, "left", "FAST");

    //Nombre empresa
    doc.setFontSize(15);
    doc.setFont("helvetica", "", "bold");
    doc.setFont("helvetica");
    doc.text(this.configuracion.empresa.nombre,108, 12,  {align:"center"});

    doc.setFontSize(14);
    doc.setFont("helvetica", "", "bold");
    doc.text(this.configuracion.empresa.subnombre,108, 18,  {align:"center"});

    doc.setFontSize(10);
    doc.setFont("helvetica", "", "normal");
    doc.text('Campus: ' + this.configuracion.sucursal.nombre,108, 24,  {align:'center'});

    doc.setFontSize(10);
    doc.setFont("helvetica", "", "bold");
    doc.text("LISTA DE INSCRITOS",108, 30,  {align:"center"});

    doc.setFontSize(8);
    doc.setFont("helvetica", "", "bold");

    doc.text("EVENTO: " + this.dato.nombre ,15, 40,  {align:"left"});
    doc.text("FECHA: del " + this.dato.fecha_inicio + " al " + this.dato.fecha_termino,15, 45,  {align:"left"});


    let columns = [
      { title: "N", dataKey: "id" },
      { title: "Nombre", dataKey: "nombre" },
      { title: "Correo", dataKey: "correo" },
      { title: "Telefono", dataKey: "telefono" },
      { title: "Codigo", dataKey: "codigo" },
      { title: "Confirmacion", dataKey: "confirmar" }
    ];

    let rows = []; let linea = 1;
    this.dato.registrados.forEach(par => {
      rows.push({
        id: linea,
        nombre: par.apellido_paterno + " " + par.apellido_materno + " " + par.nombre,
        correo: par.email,
        telefono: par.telefono,
        codigo: par.codigo_prerregistro,
        confirmar: par.codigo_confirmacion ? par.codigo_confirmacion : '--'
      });
    });

    (doc as any).autoTable({
            columns:columns, 
            body: rows,
      didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
        cell.styles.fillColor = "#ffffff";
      },
      startY: 50,
      styles: {
        fontSize: 8,
        halign: "center",
        fillColor: color
      },
      theme: "grid",
      columnStyles: {
        id: { cellWidth: 20 },
        alumno: {
          cellWidth: 40,
          halign: "left"
        }
      }
    });

    // doc.autoPrint();
    //const string = (doc as any).output('datauristring', 'evento_confirmados.pdf');
    window.open((doc as any).output('bloburl'), '_blank');
    /*const iframe = "<iframe border='0' style='border:0px' width='100%' height='100%' src='" + string + "'></iframe>"

    const x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();*/

  }

  logo_sucursal;
  logo_empresa;
  asignarLogos(logos) {
    if (logos) {
      this.logo_sucursal = logos.sucursal;
      this.logo_empresa = logos.empresa;
    }
  }
}
